import React from 'react';
import {
    Filter,
    List,
    Edit,
    Create,
    Show,
    SimpleShowLayout,
    Datagrid,
    TextField,
    DateField,
    SimpleForm,
    TextInput,
    DisabledInput,
    EditButton,
    DeleteButton,
    ShowButton
} from 'react-admin';

const ClientFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
);

export const ClientList = (props) => (
	<List title="Clients" {...props} filters={<ClientFilter />} sort={{ field: 'Name', order: 'ASC' }} >
        <Datagrid>
            <TextField source="id" />
            <TextField source="Name" />
            <ShowButton />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

const ClientTitle = ({ record }) => {
	return <span>{record ? `"${record.Name ? record.Name : ''}"` : ''}</span>;
};

export const ClientShow = (props) => (
    <Show title={<ClientTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Name" />
        </SimpleShowLayout>
    </Show>
);

const required = (message = 'Required') =>
    value => value ? undefined : message;
const validateReq = [required()];

export const ClientEdit = (props) => (
    <Edit title={<ClientTitle />} {...props}>
        <SimpleForm>
            <DisabledInput source="id" />
            <TextInput source="Name" validate={validateReq} required />
        </SimpleForm>
    </Edit>
);

export const ClientCreate = (props) => (
    <Create title="Create Client" {...props}>
        <SimpleForm>
            <TextInput source="Name" validate={validateReq} required />
        </SimpleForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/resources/clients.js